module.exports = __webpack_public_path__ + "img/renew.f70bea08.jpg";